import { MemoruHomeMeResponse } from "@API/src/component/memoruHome/me/types";

export const isTypeMemoruHomeMeResponse = (arg): arg is MemoruHomeMeResponse =>
  arg !== null &&
  typeof arg === "object" &&
  typeof arg.parentId === "number" &&
  typeof arg.email === "string" &&
  typeof arg.imageUrl === "string";
